import { render, staticRenderFns } from "./EmpAddProvider.vue?vue&type=template&id=652c4a60&"
import script from "./EmpAddProvider.vue?vue&type=script&lang=js&"
export * from "./EmpAddProvider.vue?vue&type=script&lang=js&"
import style0 from "./EmpAddProvider.vue?vue&type=style&index=0&id=652c4a60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports